import { Logout } from '@mui/icons-material';
import { Box, Button, Paper } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { useLoggedInUserLoginData } from '~/components/Auth/useLoggedInUserLoginData';
import { ChangePasswordForm } from '~/features/ChangePassword/ChangePasswordForm';
import { useSxStyles } from '~/features/ChangePassword/ChangePasswordView/useStyles';
import { redirectToLogOut } from '~/utils/helper';

export const ChangePasswordView = () => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  const userLoginData = useLoggedInUserLoginData();

  return (
    <Box sx={sxStyles.root}>
      <Box sx={sxStyles.topBar}>
        <Button
          onClick={() => {
            redirectToLogOut('Required password change cancelled');
          }}
          endIcon={<Logout />}
        >
          {t('logout')}
        </Button>
      </Box>
      <Box sx={sxStyles.content}>
        <Paper sx={sxStyles.panel}>
          <ChangePasswordForm
            username={userLoginData.fLoginUsername}
            onUpdate={() => {
              redirectToLogOut('Required password change completed');
            }}
            description={t('requiredPasswordChangeMessage')}
          />
        </Paper>
      </Box>
    </Box>
  );
};
